import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';
import { useTranslation } from 'react-i18next';

import './Contact.css';
import Header from '../../components/Header/Header'; // ✅ Header como en la versión original

const SEND_CONTACT_EMAIL_MUTATION = gql`
  mutation SendContactEmail($name: String!, $email: String!, $message: String!, $reason: String!) {
    sendContactEmail(name: $name, email: $email, message: $message, reason: $reason) {
      success
      message
    }
  }
`;

export default function Contact() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [userInput, setUserInput] = useState({
    name: "",
    email: "",
    message: "",
    reason: searchParams.get("reason") || ""
  });

  const [sendContactEmail] = useMutation(SEND_CONTACT_EMAIL_MUTATION);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserInput(prev => ({ ...prev, [name]: value }));
    setErrorMessage("");
  };

  const handleSubmit = async () => {
    const { name, email, message, reason } = userInput;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!name || !email || !message || !reason) {
      setErrorMessage(t("contact.errorFillAll"));
      return;
    }

    if (!emailRegex.test(email)) {
      setErrorMessage(t("contact.errorEmail"));
      return;
    }

    try {
      const { data } = await sendContactEmail({ variables: userInput });
      if (data.sendContactEmail.success) {
        setIsSubmitted(true);
      } else {
        setErrorMessage(t("contact.errorSendFailed") + data.sendContactEmail.message);
      }
    } catch (err) {
      console.error(err);
      setErrorMessage(t("contact.errorGeneric"));
    }
  };

  const discordLink = "https://discord.gg/pRFEHhuK9B";

  return (
    <div>
      <Header /> {/* ✅ Igual que en la versión anterior */}

      <div className="contact-wrapper">
        {!isSubmitted ? (
          <div className="form">
            <div className="contact-body">
              <h1>{t("contact.title")}</h1>
              <p>{t("contact.subtitle")}</p>

              {errorMessage && <div className="error-message">{errorMessage}</div>}

              <label>{t("contact.form.labelEmail")}</label>
              <input
                type="email"
                name="email"
                placeholder={t("contact.form.labelEmail")}
                value={userInput.email}
                onChange={handleChange}
                className="custom-input"
              />

              <label>{t("contact.form.labelName")}</label>
              <input
                type="text"
                name="name"
                placeholder={t("contact.form.labelName")}
                value={userInput.name}
                onChange={handleChange}
                className="custom-input"
              />

              <label>{t("contact.dropdown.label")}</label>
              <select
                name="reason"
                value={userInput.reason}
                onChange={handleChange}
                className="custom-select"
              >
                <option value="">{t("contact.dropdown.placeholder")}</option>
                <option value="Specialized AI Solutions">
                  {t("contact.dropdown.options.specializedAi")}
                </option>
                <option value="Technical Support">
                  {t("contact.dropdown.options.technicalSupport")}
                </option>
                <option value="General Purpose">
                  {t("contact.dropdown.options.generalPurpose")}
                </option>
                <option value="Coins">
                  {t("contact.dropdown.options.coins")}
                </option>
                <option value="Consult Pilot plan">
                  {t("contact.dropdown.options.pilotPlan")}
                </option>
              </select>

              <label>{t("contact.form.labelMessage")}</label>
              <textarea
                name="message"
                value={userInput.message}
                onChange={handleChange}
                className="custom-textarea"
                rows="6"
                placeholder={t("contact.form.labelMessage") + "..."}
              />

              <div className="form-footer">
                <button className="custom-button" onClick={handleSubmit}>
                  {t("contact.form.buttonSend")}
                </button>
                <div className="discord-link">
                  <a href={discordLink} target="_blank" rel="noopener noreferrer">
                    {t("contact.discord.join")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="isSubmited-container">
            <h1>{t("contact.submitted.thankYou")}</h1>
            <h3>{t("contact.submitted.followUp")}</h3>
            <div className="discord-link">
              <a href={discordLink} target="_blank" rel="noopener noreferrer">
                {t("contact.discord.join")}
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
